var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "flex flex-row justify-start items-center"
  }, [_c('div', {
    staticClass: "bg-indigo-600 h-2 w-2 rounded-full mr-2.5"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('span', {
    staticClass: "font-medium text-base"
  }, [_vm._v(_vm._s(_vm.textContent))]), _vm._v(" "), _c('span', {
    staticClass: "italic"
  }, [_vm._v(_vm._s(_vm.details))])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }